import React from 'react'
import { DateRangeType, DateType } from '../_config/types'
import DateRangePicker from '../components/DateRangePicker'
import DatePicker from 'react-date-picker'
import Icon from './icons'

import 'react-date-picker/dist/DatePicker.css'
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css'
import 'react-calendar/dist/Calendar.css'

type Value = DateType | DateRangeType

type CustomDatePickerProps = {
    type?: 'range' | null
    value?: Value
    onChange?: (value: Value) => void
    minDate?: Date
    maxDate?: Date
    format?: string
    clearIcon?: React.ReactNode
    calendarIcon?: React.ReactNode
    error?: string
    className?: string
    disabled?: boolean
    showClearIcon?: boolean
    size?: 'md' | 'sm'
    resetStartDate?: Date
    resetEndDate?: Date
}

const SIZE_CONFIG = {
    md: {
        wrapper: 'min-w-[13.150rem] max-w-[13.150rem]',
        text: 'text-[0.667rem]',
        height: 'h-[1.709rem]',
        iconSize: 1,
        errorText: 'text-[.542rem]',
    },
    sm: {
        wrapper: 'max-w-[9rem]',
        text: 'text-[0.438rem]',
        height: 'h-[1.2rem]',
        iconSize: 0.65,
        errorText: 'text-[.4rem]',
    },
}

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({
    disabled = false,
    type = null,
    value,
    onChange,
    minDate = undefined,
    maxDate = undefined,
    format = 'MM-dd-y',
    clearIcon = null,
    calendarIcon = null,
    error,
    className = '',
    showClearIcon = true,
    size = 'md',
    resetStartDate,
    resetEndDate,
}) => {
    const config = SIZE_CONFIG[size]

    return (
        <div className={`relative ${config.wrapper} rounded-[0.267rem] w-full ${className}`}>
            {type == 'range' ? (
                <DateRangePicker
                    data-testid="date-range-picker"
                    type="range"
                    value={value as DateRangeType}
                    onChange={onChange}
                    disabled={disabled}
                    minDate={minDate}
                    maxDate={maxDate}
                    format={'MM d y'}
                    clearIcon={showClearIcon ? <Icon name="reset" size={config.iconSize} /> : null}
                    calendarIcon={<Icon name="calendar" size={config.iconSize} />}
                    size={size}
                    resetStartDate={resetStartDate}
                    resetEndDate={resetEndDate}
                />
            ) : (
                <DatePicker
                    data-testid={'date-range-picker'}
                    dayPlaceholder="DD"
                    monthPlaceholder="MM"
                    yearPlaceholder="YYYY"
                    value={value}
                    onChange={onChange}
                    onCalendarOpen={() => {}}
                    onCalendarClose={() => {}}
                    disabled={disabled}
                    className={`rounded-[0.267rem] bg-white ${config.text} w-full ${config.height} items-center ${error ? 'border-red-500 border-2' : 'border border-[#D4D4DA]'}`}
                    minDate={minDate}
                    maxDate={maxDate}
                    format={'MM d y'}
                    clearIcon={showClearIcon ? <Icon name="reset" size={config.iconSize} /> : null}
                    calendarIcon={<Icon name="calendar" size={config.iconSize} />}
                />
            )}

            {error && <p className={`text-error ${config.errorText}`}>{error}</p>}
        </div>
    )
}

export default CustomDatePicker
